var _g, _path, _g2, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg040201(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 160,
    viewBox: "0 0 177 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_228_276)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_228_276)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.6172,
    y: 19.1284,
    width: 113.635,
    height: 77.8255,
    rx: 8.08914,
    transform: "rotate(25.0799 53.6172 19.1284)",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.2669,
    y: 15.4025,
    width: 119.24,
    height: 83.4301,
    rx: 10.8915,
    transform: "rotate(25.0799 52.2669 15.4025)",
    stroke: "white",
    strokeWidth: 5.60462,
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.945 130.529C125.051 134.575 120.236 136.32 116.19 134.426L27.9214 93.1164C23.8751 91.2227 22.1301 86.4074 24.0238 82.3611L37.4785 53.6121L140.4 101.78L126.945 130.529Z",
    fill: "#E8E8E8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_228_276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.033 81.8195C105.816 84.3724 104.166 87.8973 101.064 88.1644L75.8862 90.3318C72.7841 90.5988 70.5563 87.4076 71.8761 84.5877L82.5879 61.6995C83.9076 58.8796 87.7852 58.5458 89.5675 61.0987L104.033 81.8195Z",
    fill: "#FF4C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0249 91.9436L101.203 89.7762C105.545 89.4024 107.855 84.4675 105.36 80.8934L90.894 60.1726C88.3988 56.5985 82.9702 57.0658 81.1226 61.0138L70.4108 83.9019C68.5631 87.8498 71.6821 92.3175 76.0249 91.9436Z",
    stroke: "white",
    strokeWidth: 3.23566,
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_228_276",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 56,
    width: 41,
    height: 38
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0249 91.9435L101.203 89.7761C105.545 89.4023 107.855 84.4673 105.36 80.8932L90.894 60.1725C88.3988 56.5984 82.9702 57.0657 81.1226 61.0136L70.4108 83.9018C68.5631 87.8497 71.6821 92.3174 76.0249 91.9435Z",
    fill: "#FF4C53",
    stroke: "white",
    strokeWidth: 3.23566,
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_228_276)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.1509,
    y: 21.7024,
    width: 51.088,
    height: 50.133,
    transform: "rotate(25.0799 86.1509 21.7024)",
    fill: "#E0A89D",
    style: {
      mixBlendMode: "lighten"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_228_276",
    x: 16.0687,
    y: 14.9734,
    width: 145.029,
    height: 127.775,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.404457
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.808914
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_228_276"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_228_276",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_228_276",
    x: 66.6302,
    y: 54.9198,
    width: 42.994,
    height: 40.6862,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.404457
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.808914
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_228_276"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_228_276",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_228_276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144.599,
    height: 107.609,
    fill: "white",
    transform: "translate(45.6133 0.531494) rotate(25.0799)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg040201);
export default __webpack_public_path__ + "static/media/img_04_02_01.436a05155b78baed23a17afc9ce3f631.svg";
export { ForwardRef as ReactComponent };